<template>
  <div class="row">
    <div v-for="product in products" :key="product.id" class="product col-lg-2 col-md-4 col-sm-6 cl-xs-12">
      <router-link :to="{ name: 'Product', params: { productId: product.id }}">
        <div class="image"><img :src="product.imageUrl"/></div>
        <span v-if="product.featured" class="badge badge-success">Featured</span>
        <p class="name">{{ product.name }}</p>
        <p class="price"><strong>{{ pointsDisplayed(product.points, product.taxPoints) | numToLocale }}</strong>points</p>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      currentPage: 0,
    }
  },
  computed: {
    ...mapState({
      grossUpTaxes: state => state.company.grossUpTaxes,

      products: state => state.product.hotItems,
    }),
    hasPrevious: function () { return this.currentPage > 0},
    hasNext: function () { return this.products.length === 20},
  },
  methods: {
    pointsDisplayed: function (productPoints, taxPoints) {
      if (this.grossUpTaxes) {
        return productPoints + taxPoints
      } else {
        return productPoints
      }
    },
  },
  created () {
    this.$store.dispatch('product/fetchHotProducts', {
      page: this.currentPage,
    })
  }
}
</script>

<style lang="scss" scoped>
.product{
  .image{
    width: 100%;
    float: left;
    margin-right: 16px;
    height: auto;
    img{
      max-width: 180px;
      vertical-align: middle;
      width: 100%;
      height: auto;
    }
  }
}
@media all and (max-width: 450px){
  .product{
    .image{
      width: 150px;
      float: left;
      margin-right: 16px;
      height: auto;
      img{
        max-width: 150px;
        vertical-align: middle;
      }
    }
  }
}
</style>
